import React, {Component} from 'react';
import PropTypes from "prop-types";
import StaticFunctions from "./StaticFunctions";

class InputField extends Component {

    static propTypes = {
        name: PropTypes.string.isRequired,
    };

    static defaultProps = {
        type: 'text',
        className: 'inputField',
        value: '',
        autoFocus: false,
        isRequired: false,
        disabled: false,
        inValidClass: 'error',
        validate: null,
        minLength: 0,
        onFocus: () => {},
        onBlur: () => {},
        onChange: () => {},
        onKeyDown: () => {},
    };

    constructor(props) {

        super(props);

        this.state = {
            valid: true,
            value: (props.value) ? props.value : '',
            resetValue: (props.value) ? props.value : '',
            hasBeenFocused: false,
        };

        this.setType = this.setType.bind(this);
        this.setValid = this.setValid.bind(this);

        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);

        this.validate = this.validate.bind(this);
        this.validateLength = this.validateLength.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.validatePassword = this.validatePassword.bind(this);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.value !== this.props.value) {
            this.setState({
                value: (nextProps.value) ? nextProps.value : '',
                resetValue: (nextProps.value) ? nextProps.value : '',
            });
        }

    }

    setType() {

        const type = this.props.type;

        return (type === 'email') ? 'text' : type;

    }

    setValid(valid) {

        if (valid !== this.state.valid) {
            this.setState({
                valid: (valid === true)
            });
        }

    }

    onFocus() {

        this.setState({
            hasBeenFocused: true,
        });

    }

    onBlur() {

        this.validate();

    }

    onValueChange(event) {

        if (!this.props.disabled) {
            const value = event.target.value;

            this.setState({
                value,
            });
        }

    }

    onKeyDown(event) {

        if (event.keyCode === 13) {
            this.validate();
        } else if (event.keyCode === 27) {
            this.props.onKeyDown(this.props.name, this.state.resetValue, true);

            this.setState({
                value: this.state.resetValue
            });
        }

    }

    validate(init = false) {

        let valid = true;

        if (this.state.hasBeenFocused) {
            if (this.props.isRequired && this.state.value === '') valid = false;

            if (this.props.validate) {
                valid = this.props.validate(this.state.value);
            } else {
                if (this.props.minLength > 0) {
                    valid = this.validateLength();
                } else if (this.props.type === 'email') {
                    valid = this.validateEmail();
                } else if (this.props.type === 'password') {
                    valid = this.validatePassword();
                }
            }

            if (!init) this.setValid(valid);
        }

        return valid;

    }

    render() {

        const {value, isRequired, inValidClass, validate, minLength, ...inputProps} = {...this.props};
        const valid = this.validate(true);

        inputProps.type = this.setType();
        inputProps.className = [this.props.className, (!valid) ? this.props.inValidClass : ''].join(' ').trim();

        return (
            <input
                {...inputProps}
                value={this.state.value}
                onFocus={(event) => {
                   this.onFocus();
                   inputProps.onFocus(event, this.props.name, event.target.value, valid);
                }}
                onBlur={(event) => {
                   this.onBlur();
                   inputProps.onBlur(event, this.props.name, event.target.value, valid);
                }}
                onChange={(event) => {
                   this.onValueChange(event);
                   inputProps.onChange(event, this.props.name, event.target.value, valid);
                }}
                onKeyDown={(event) => {
                   this.onKeyDown(event);
                   inputProps.onKeyDown(event, this.props.name, event.target.value, valid);
                }}
            />
        );

    }

    validateLength() {

        return (this.state.value.length >= this.props.minLength);

    }

    validateEmail() {

        return StaticFunctions.validateEmail(this.state.value);

    }

    validatePassword() {

        const passwordMinLength = (this.props.minLength > 0) ? this.props.minLength : 8;
        const passwordMinSecurityLevel = 3;
        const securityLevel = StaticFunctions.getSecurityLevelOfPassword(this.state.value, passwordMinLength);

        return (securityLevel >= passwordMinSecurityLevel);

    }

}

export default InputField;